// packages import
import { Box, Typography } from '@mui/material'
import { ThreeCircles } from 'react-loader-spinner'
// others
import palette from '../../theme/palette'

export const CommonLoader = () => (
  <Box minHeight='calc(100vh - 16px)' display='flex' alignItems='center' justifyContent='center'>
    <Box>
      <ThreeCircles
        height="50"
        width="50"
        color={palette.primary.main}
        wrapperStyle={{ justifyContent: 'center' }}
        wrapperClass=""
        visible={true}
        ariaLabel="three-circles-rotating"
      />
      <Typography mt={2}>App is loading please wait...</Typography>
    </Box>
  </Box>
)